import React from 'react';
import Skeleton from '../../Skeleton/Skeleton';
import {
  FunctionMetric,
  FunctionMetricDot,
  FunctionMetricsContainer,
  FunctionMetricTitle,
} from './FunctionBehaviorChart.styles';
import { InfoPopover } from '../../HoverPopover/InfoPopover';

interface MetricHeaderProps {
  loading: boolean;
  metrics: {
    title: string;
    metric?: React.ReactNode;
    color?: string;
    hidden?: boolean;
    tooltip?: string;
    tooltipUrl?: string;
  }[];
}

export function MetricHeader({ loading, metrics }: MetricHeaderProps) {
  const hasMetrics = metrics.some((m) => !m.hidden);

  if (!hasMetrics) {
    return <FunctionMetricsContainer>Select fields to show</FunctionMetricsContainer>;
  }

  return (
    <FunctionMetricsContainer>
      {metrics
        .filter((m) => !m.hidden)
        .map(({ title, metric, color, tooltip, tooltipUrl }) => (
          <FunctionMetric key={title}>
            {loading || metric === undefined ? (
              <MetricSkeleton />
            ) : (
              <>
                {color && <FunctionMetricDot size={8} color={color} />}
                <FunctionMetricTitle>
                  {title}
                  {tooltip && <InfoPopover body={tooltip} href={tooltipUrl} />}
                </FunctionMetricTitle>
                {metric}
              </>
            )}
          </FunctionMetric>
        ))}
    </FunctionMetricsContainer>
  );
}

function MetricSkeleton() {
  return <Skeleton height={17} width={100} />;
}
